import { Module, Mutation, Action } from "vuex-module-decorators";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { RootState } from "@/store";
import { queryRequest, handlePaginationData } from "@/utils/request";
import { getMyBonusAccount } from "@/graphql/bounty.gql";
import {
  queryStoreScanRecord,
  StoreScanRecordMonth
} from "@/graphql/warehouse.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import { formatByDate, getDateBefore36 } from "@/utils/common/date";
import type { PaginationDataState } from "@/types";
import { WarehouseRecordTypeEnums } from "@/enums/warehouse";

export interface WarehouseHistoryState extends PaginationDataState {
  recordType: string;
  searchCondition: any;
}

const defaultSearchInstance = () => ({
  keyword: ""
});
@Module({ name: "WarehouseHistoryOldModule", namespaced: true })
export default class WarehouseHistoryOldModule
  extends PaginationModule<WarehouseHistoryState, RootState>
  implements WarehouseHistoryState {
  public listData: any[] = [];
  public recordType: string = ""; // 出入库类型
  public searchCondition: any = defaultSearchInstance(); // 筛选条件
  public openFilterFlag: boolean = false; // 打开筛选模块
  public timeSumMap = {}; // 时间统计集合
  public filterData: any = []; // 筛选条件数据

  @Mutation
  setFilterDataMutation(data: any[]) {
    this.filterData = data || [];
  }
  @Mutation
  setRecordTypeMutation(data: string) {
    this.recordType = data;
  }
  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }

  @Mutation
  setSearchConditionMutation({ key = "", value = "" } = {}) {
    if (!key && !value) {
      this.searchCondition = defaultSearchInstance();
    } else {
      this.searchCondition[key] = value;
    }
  }
  @Mutation
  setOpenFilterFlagMutation(data: boolean) {
    this.openFilterFlag = data ?? false;
  }
  @Mutation
  setTimeSumMapMutation({ key = "", value = "" } = {}) {
    if (!(key && value)) {
      this.timeSumMap = {};
    } else {
      this.timeSumMap[key] = value;
    }
  }

  @Action
  async queryListAction({ callback = data => data } = {}) {
    const {
      state: {
        recordType,
        searchCondition,
        paginationData,
        paginationData: { pageNum, pageSize }
      },
      commit
    } = this.context;
    const [start, end] = getDateBefore36();

    let tempParams;
    switch (recordType) {
      case WarehouseRecordTypeEnums.IN:
        tempParams = { recordType };
        break;
      case WarehouseRecordTypeEnums.OUT:
        tempParams = { recordType }; //isWarrantyCard: "!3"
        break;
      case WarehouseRecordTypeEnums.BATCH_OUT:
        tempParams = {
          recordType: WarehouseRecordTypeEnums.OUT
          // isWarrantyCard: "3"
        };
        break;
    }
    let { data = [], totalCount } = handlePaginationData(
      await queryRequest({
        query: queryStoreScanRecord,
        variables: {
          input: {
            // recordType,
            // ...tempParams,
            attribute: searchCondition.keyword || undefined,
            scanTimeBegin: searchCondition.startTime || formatByDate(start),
            scanTimeEnd: searchCondition.endTime || formatByDate(end)
          },
          pageInput: { pageNum, pageSize }
        }
      })
    );
    data = await callback(data);
    commit(
      pageNum === 1 ? "saveListDataMutation" : "addListDataMutation",
      data
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  async queryFilterDataAction() {
    const data = await queryRequest({
      query: queryDataDictionaryListLang,
      variables: {
        input: {
          ddCode: "BONUS_SOURCE", // 奖励金筛选
          lang: window.i18n.locale
        }
      }
    });
    this.context.commit("setFilterDataMutation", data);
  }

  @Action
  async queryListSumAction(variables: any) {
    // 批量出库 零售出库合并，用一个类型
    // if (variables.recordType === WarehouseRecordTypeEnums.BATCH_OUT) {
    //   variables.recordType = WarehouseRecordTypeEnums.OUT;
    // }

    const data = await queryRequest({
      query: StoreScanRecordMonth,
      variables
    });
    data.forEach(o => {
      this.context.commit("setTimeSumMapMutation", {
        key: o.year + String(o.month).padStart(2, "0"),
        value: o
      });
    });
  }
}
